<template>
	<div class="coupon">
		<div class="couponList">
			<div class="item" v-for="i in couponList" :key="i.index">
					<div class="con leftPrice">
							<h4><span>￥</span>100</h4>
							<p>满5000元减</p>
					</div>
					<div class="con centerCon">
							<p class="title">优惠券名称优惠券名优惠券名称优惠券名</p>
							<p class="time">2021.01.01—2021.01.01</p>
					</div>
					<div class="con rightBtn">
							<span v-if="i%2 == 0">领取</span>
							<span class="toDetailList" v-else>已领取 <img src="@/assets/right.png" alt=""> </span>
					</div>
			</div>
		</div>
		<div class="bottomBtn">
			<span>全部领取</span>
		</div>
	</div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      couponId: '',
      couponList: []
    }
  },
  computed: {},
  mounted() {
    this.couponId = this.$route.query.couponId
    console.log(this.couponId)
    let param = {
      goodsId: this.couponId || '10152'
    }
    this.$service.getGoodsBonus(param).then(res => {
      this.couponList = res.data
    })
  },
  methods: {

  }
}
</script>
<style lang="stylus" scoped>

.couponList
	padding-bottom: 70px
	.item
		display: flex
		align-items: center
		width: 343px
		height: 92px
		background: linear-gradient(268.22deg, #FF9268 -13.62%, #EC6452 97.96%)
		border-radius: 8px
		margin: 10px 16px
		color: #fff
		.leftPrice
			flex: 1
			text-align: center
			h4
				font-size: 30px
				font-weight: 500
				span
					font-size: 15px
			p
				font-size: 12px
				opacity: 0.8
		.centerCon
			flex: 2
			p.title
				font-size: 12px
				line-height: 17px
			p.time
				font-size: 10px
				opacity 0.8
				margin-top: 5px
		.rightBtn
			flex: 1
			text-align: center
			span
				font-size: 16px
				font-weight: 500
				img
					width: 5px
					height: 11px
					margin-left: 7px
			span.toDetailList
				color: rgba(255,255,255,0.6)
.coupon
	.bottomBtn
		position: fixed
		bottom: 20px
		left: 16px
		width: 343px
		height: 44px
		line-height: 44px
		text-align: center
		color: #fff
		font-size: 16px
		border-radius: 24px
		background: #FC4C00
</style>
